import {ApiConnection} from 'powtoon-api/src/apiConnection'
import {UserProfile, UserRecommendations, UserPermissions} from './types'
import {IChangePasswordApiArgs, UserStudioSettings} from 'powtoon-services/current-user/types'
import {updateUserStudioSettings} from 'powtoon-services/current-user/userStudioSettingsVersioning'
import {UserBillingInfo, UserProfileInfo} from '.'

export const getUserProfile = (connection: ApiConnection) => () => {
  return connection.get<UserProfileInfo>('user/me/profile', {includeResponseStatus: true})
}

export const getUserBillingInfo = (connection: ApiConnection) => () => {
  return connection.get<UserBillingInfo>('users/me/settings/billing')
}

export const patchUserProfile = (connection: ApiConnection) => (data: object) => {
  return connection.patch<UserProfile>('user/me/profile', data)
}

export const getUserPermissions = (connection: ApiConnection) => () => {
  return connection.get<UserPermissions>('user/me/permissions')
}

export const getUserRecommendations = (connection: ApiConnection) => () => {
  return connection.get<UserRecommendations>('users/me/recommendations')
}

export const getUserSettings = (connection: ApiConnection) => <T>(appName?: string) => {
  return connection.get<T>(`users/me/settings${appName ? `/${appName}` : ''}`)
}

export const saveUserSettings = (connection: ApiConnection) => (data: object, appName?: string) => {
  return connection.post(`users/me/settings${appName ? `/${appName}` : ''}`, data)
}

export const getUserStudioSettings = (connection: ApiConnection) => () => {
  return connection.get<object>('user/studio-settings', {transformResponseToCamelCase: false})
    .then(settings => updateUserStudioSettings(settings))
}

export const storeUserStudioSettings = (connection: ApiConnection) => (userSettings: UserStudioSettings) => {
  return connection.post<object>('user/studio-settings', userSettings as object )
}

export const getUserRolesInGroups = (connection: ApiConnection) => () => {
  return connection.get<object>('user/groups')
}

// type EmailType = 'mobile_app_promotion' | 'some_other_email_type
type EmailType = 'mobile_app_promotion'
export const sendEmail = (connection: ApiConnection) => (emailType: EmailType, userProfile: UserProfile) => {
  const data: object = {
    email_type: emailType,
    recipients: [userProfile.email],
    context: {
      lead_name: userProfile.firstName
    }
  }
  return connection.post<object>('services/send-email', {transformResponseToCamelCase: false}, data)
}

export const getOrgPermissionsForCurrentUser = (connection: ApiConnection) => () => {
  return connection.get<object>('org/users/me/permissions')
}

export const saveUserStudioSettings = (connection: ApiConnection) => (data: UserStudioSettings) => {
  return connection.post('user/studio-settings', data)
}

export const changePassword = (connection: ApiConnection) => (
  {oldPassword, newPassword, repeatPassword}: IChangePasswordApiArgs
) => (
  connection.put('users/me/password', {oldpassword: oldPassword, password1: newPassword, password2: repeatPassword})
)

export const getSessionStatus = (connection: ApiConnection) => () => connection.get('session-info')
